import { ProductCategoryId } from '~/enums';

/**
 * 特集一覧カテゴリの生産地名称を取得
 * @param producingAreas 生産地
 * @returns 特集一覧カテゴリの生産地名称
 */
export const getArchiveAreaCategoryCode = (producingAreas?: string[]) => {
  if (!producingAreas?.length) {
    return;
  }
  if (producingAreas.includes('FRANCE')) {
    for (const area of producingAreas) {
      if (['BORDEAUX', 'BOURGOGNE', 'CHAMPAGNE'].includes(area)) {
        return area;
      }
    }
    return 'FRANCE_AND_OTHER';
  }
  for (const area of producingAreas) {
    if (['ITALIA', 'CALIFORNIA', 'JAPAN'].includes(area)) {
      return area;
    }
  }
  return 'OTHER_COUNTRIES_REGIONS';
};

/**
 * 特集一覧カテゴリのタイプ名称を取得
 * @param categoryId 商品カテゴリid
 * @param color ワインの色名
 * @returns 特集一覧カテゴリのタイプ名称
 */
export const getArchiveColorCategoryCode = (categoryId?: number, color?: string) => {
  if (!(categoryId === ProductCategoryId.WINE)) {
    return 'other_than_wine';
  }
  switch (color) {
    case '赤ワイン':
      return 'red_wine';
    case '白ワイン':
      return 'white_wine';
    case 'ミックス':
      return 'mix_wine';
    case 'スパークリング':
    case 'スパークリングワイン':
    case '赤スパークリング':
    case '白スパークリング':
    case 'ロゼスパークリング':
      return 'sparkling_wine';
    default:
      return 'other_wine';
  }
};

export const getArchiveAreaCategoryText = (areaCode?: string) => {
  if (!areaCode) {
    return [];
  }
  switch (areaCode) {
    case 'BORDEAUX':
      return ['フランス', 'ボルドー'];
    case 'BOURGOGNE':
      return ['フランス', 'ブルゴーニュ'];
    case 'CHAMPAGNE':
      return ['フランス', 'シャンパーニュ'];
    case 'FRANCE_AND_OTHER':
      return ['フランス', 'その他フランス'];
    case 'ITALIA':
      return ['イタリア'];
    case 'CALIFORNIA':
      return ['カリフォルニア'];
    case 'JAPAN':
      return ['日本'];
    default:
      return ['その他国・地域'];
  }
};

/**
 * 特集の色タイプコードから名称への変換
 * @param categoryCode 特集の色タイプ
 * @returns 色タイプに対応する名称を返す
 */
export const getArchiveColorCategoryText = (categoryCode?: string) => {
  if (!categoryCode) {
    return;
  }
  switch (categoryCode) {
    case 'red_wine':
      return '赤ワイン';
    case 'white_wine':
      return '白ワイン';
    case 'mix_wine':
      return 'ミックス';
    case 'sparkling_wine':
      return 'スパークリングワイン';
    default:
      return 'その他';
  }
};
